<template>
  <div
    ref="kt_modal_faturamento_editar_veiculo"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_faturamento_editar_veiculo"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">
              Detalhamento de Veículos novos
            </h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Tipo da operação</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['tpOp'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.tpOp"
              >
                <option value="1">1 - Venda concessionária</option>
                <option value="2">
                  2 - Faturamento direto para consumidor final
                </option>
                <option value="3">
                  3 - Venda direta para grandes consumidores (frotista, governo,
                  etc...)
                </option>
                <option value="4">0 - Outros</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["tpOp"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Chassi do Veículo</label>
              <input
                type="text"
                id="txtchassi"
                :class="[
                  'form-control mb-2',
                  errosValidacao['chassi'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.chassi"
                maxlength="6"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["chassi"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Código da cor</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['cCor'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.cCor"
                maxlength="4"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["cCor"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Descrição da cor</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['xCor'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.xCor"
                maxlength="40"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["xCor"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Potência do Motor(CV)</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['pot'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.pot"
                maxlength="4"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["pot"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Cilindradas</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['cilin'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.cilin"
                maxlength="4"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["cilin"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Peso Líquido</label>
              <CurrencyInput
                class="form-control mb-2 text-danger"
                placeholder="Peso Líquido"
                style="text-align: right"
                v-model="this.refVeic.pesoL"
                :options="options"
                :class="[
                  'form-control mb-2',
                  errosValidacao['pesoL'] ? 'is-invalid' : '',
                ]"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["pesoL"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Peso Bruto</label>
              <CurrencyInput
                class="form-control mb-2 text-danger"
                placeholder="Peso Bruto"
                style="text-align: right"
                v-model="this.refVeic.pesoB"
                :options="options"
                :class="[
                  'form-control mb-2',
                  errosValidacao['pesoB'] ? 'is-invalid' : '',
                ]"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["pesoB"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Serial (série)</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['nSerie'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.nSerie"
                maxlength="9"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["nSerie"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Tipo de Combustível</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['tpComb'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.tpComb"
              >
                <option value="01">01 - Álcool</option>
                <option value="02">02 - Gasolina</option>
                <option value="03">03 - Diesel</option>
                <option value="04">04 - Gasogênio</option>
                <option value="05">05 - Gás Metano</option>
                <option value="06">06 - Elétrico/Fonte Interna</option>
                <option value="07">07 - Elétrico/Fonte Externa</option>
                <option value="08">
                  08 - Gasolina/Gás Natural Combustível
                </option>
                <option value="09">09 - Álcool/Gás Natural Combustível</option>
                <option value="10">10 - Diesel/Gás Natural Combustível</option>
                <option value="11">11 - Vide/Campo/Observação</option>
                <option value="12">12 - Álcool/Gás Natural Veicular</option>
                <option value="13">13 - Gasolina/Gás Natural Veicular</option>
                <option value="14">14 - Diesel/Gás Natural Veicular</option>
                <option value="15">15 - Gás Natural Veicular</option>
                <option value="16">16 - Álcool/Gasolina</option>
                <option value="17">
                  17 - Gasolina/Álcool/Gás Natural Veicular
                </option>
                <option value="18">18 - Gasolina/elétrico</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["tpComb"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Número de Motor</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['nMotor'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.nMotor"
                maxlength="21"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["nMotor"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Capacidede máxima de tração</label>
              <CurrencyInput
                class="form-control mb-2 text-danger"
                style="text-align: right"
                v-model="this.refVeic.CMT"
                :options="options"
                :class="[
                  'form-control mb-2',
                  errosValidacao['CMT'] ? 'is-invalid' : '',
                ]"
              ></CurrencyInput>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["CMT"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Distância entre eixos</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['dist'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.dist"
                maxlength="4"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["dist"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Ano Modelo de Fabricação</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['anoMod'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.anoMod"
                maxlength="4"
                v-mask="['####']"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["anoMod"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Ano de Fabricação</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['anoFab'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.anoFab"
                maxlength="4"
                v-mask="['####']"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["anoFab"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Tipo de Pintura</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['tpPint'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.tpPint"
                maxlength="1"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["tpPint"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Tipo de Veículo</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['tpVeic'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.tpVeic"
              >
                <option value="02">02 - CICLOMOTO</option>
                <option value="03">03 - MOTONETA</option>
                <option value="04">04 - MOTOCICLO</option>
                <option value="05">05 - TRICICLO</option>
                <option value="06">06 - AUTOMÓVEL</option>
                <option value="07">07 - MICRO-ÔNIBUS</option>
                <option value="08">08 - ÔNIBUS</option>
                <option value="10">10 - REBOQUE</option>
                <option value="11">11 - SEMIRREBOQUE</option>
                <option value="13">13 - CAMIONETA</option>
                <option value="14">14 - CAMINHÃO</option>
                <option value="17">17 - CAMINHÃO TRATOR</option>
                <option value="18">18 - TRATOR RODAS</option>
                <option value="19">19 - TRATOR ESTEIRAS</option>
                <option value="20">20 - TRATOR MISTO</option>
                <option value="21">21 - QUADRICICLO</option>
                <option value="22">22 - ESP / ÔNIBUS</option>
                <option value="23">23 - CAMINHONETE</option>
                <option value="24">24 - CARGA/CAM</option>
                <option value="25">25 - UTILITÁRIO</option>
                <option value="26">26 - MOTOR-CASA</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["tpVeic"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Espécie de Veículo</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['espVeic'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.espVeic"
              >
                <option value="1">1 - PASSAGEIRO</option>
                <option value="2">2 - CARGA</option>
                <option value="3">3 - MISTO</option>
                <option value="4">4 - CORRIDA</option>
                <option value="5">5 - TRAÇÃO</option>
                <option value="6">6 - ESPECIAL</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["espVeic"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Condição do VIN</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['VIN'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.VIN"
              >
                <option value="N">N - Normal</option>
                <option value="R">R - Remarcado</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["VIN"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Condição do Veículo</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['condVeic'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.condVeic"
              >
                <option value="1">1 - Acabado</option>
                <option value="2">2 - Inacabado</option>
                <option value="3">3 - Semiacabado</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["condVeic"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Código Marca Modelo</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['cMod'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.cMod"
                maxlength="6"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["cMod"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Código da Cor</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['cCorDENATRAN'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.cCorDENATRAN"
              >
                <option value="01">01 - AMARELO</option>
                <option value="02">02 - AZUL</option>
                <option value="03">03 - BEGE</option>
                <option value="04">04 - BRANCA</option>
                <option value="05">05 - CINZA</option>
                <option value="06">06 - -DOURADA</option>
                <option value="07">07 - GRENÁ</option>
                <option value="08">08 - LARANJA</option>
                <option value="09">09 - MARROM</option>
                <option value="10">10 - PRATA</option>
                <option value="11">11 - PRETA</option>
                <option value="12">12 - ROSA</option>
                <option value="13">13 - ROXA</option>
                <option value="14">14 - VERDE</option>
                <option value="15">15 - VERMELHA</option>
                <option value="16">16 - FANTASIA</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["cCorDENATRAN"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 fv-row mb-6"
            >
              <label class="form-label">Capacidade máxima de lotação</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['lota'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.lota"
                maxlength="3"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["lota"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row mb-6"
            >
              <label class="form-label">Restrição</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['tpRest'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeic.tpRest"
              >
                <option value="0">0 - Não há</option>
                <option value="1">1 - Alienação Fiduciária</option>
                <option value="2">2 - Arrendamento Mercantil</option>
                <option value="3">3 - Reserva de Domínio</option>
                <option value="4">4 - Penhor de Veículos</option>
                <option value="9">9 - Outras</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["tpRest"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CurrencyInput from "@/components/text/CurrencyInput";

const refVeicInicializado = {
  tpOp: "1",
  chassi: "",
  cCor: "",
  xCor: "",
  pot: "",
  cilin: "",
  pesoL: 0,
  pesoB: 0,
  nSerie: "",
  tpComb: "02",
  nMotor: "",
  CMT: 0,
  dist: "",
  anoMod: "",
  anoFab: "",
  tpPint: "",
  tpVeic: "02",
  espVeic: "1",
  VIN: "N",
  condVeic: "1",
  cMod: "",
  cCorDENATRAN: "01",
  lota: "",
  tpRest: "0",
};

export default {
  components: { CurrencyInput },
  emits: ["exibirModalEditarVeiculo", "adicionarVeiculo", "editarVeiculo"],
  props: {
    index: { type: Number, required: true, default: -1 },
    refVeicFaturamento: { type: Object, required: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = {};
      this.loading = true;

      if (this.validar() === true) {
        if (this.index === -1) {
          this.$emit("adicionarVeiculo", this.refVeic);
        } else {
          this.$emit("editarVeiculo", this.refVeic, this.index);
        }
        hideModal(this.$refs.kt_modal_faturamento_editar_veiculo);
        this.$emit("exibirModalEditarVeiculo", false);
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }

      this.loading = false;
    },
    validar() {
      let result = true;

      if (!this.refVeic.tpOp) {
        this.errosValidacao.tpOp = "Informe o Tipo da Operação";
        result = false;
      } else if (this.refVeic.tpOp.trim().length <= 0) {
        this.errosValidacao.tpOp = "Informe o Tipo da Operação";
        result = false;
      }

      if (!this.refVeic.chassi) {
        this.errosValidacao.chassi = "Informe o Chassi do veículo";
        result = false;
      } else if (this.refVeic.chassi.trim().length <= 0) {
        this.errosValidacao.chassi = "Informe o Chassi do veículo";
        result = false;
      }

      if (!this.refVeic.cCor) {
        this.errosValidacao.cCor = "Informe a Cor";
        result = false;
      } else if (this.refVeic.cCor.trim().length <= 0) {
        this.errosValidacao.cCor = "Informe a Cor";
        result = false;
      }

      if (!this.refVeic.xCor) {
        this.errosValidacao.xCor = "Informe a Descrição da Cor";
        result = false;
      } else if (this.refVeic.xCor.trim().length <= 0) {
        this.errosValidacao.xCor = "Informe a Descrição da Cor";
        result = false;
      }

      if (!this.refVeic.pot) {
        this.errosValidacao.pot = "Informe a Potência do Motor (CV)";
        result = false;
      } else if (isNaN(this.refVeic.pot)) {
        this.errosValidacao.pot =
          "A Potência do Motor deve ser um número válido";
        result = false;
      }

      if (!this.refVeic.cilin) {
        this.errosValidacao.cilin = "Informe as Cilindradas";
        result = false;
      } else if (isNaN(this.refVeic.cilin)) {
        this.errosValidacao.cilin = "As Cilindradas devem ser um número válido";
        result = false;
      }

      if (!this.refVeic.pesoL) {
        this.errosValidacao.pesoL = "Informe o Peso Líquido";
        result = false;
      } else if (isNaN(this.refVeic.pesoL)) {
        this.errosValidacao.pesoL = "O Peso Líquido deve ser um número válido";
        result = false;
      }

      if (!this.refVeic.pesoB) {
        this.errosValidacao.pesoB = "Informe o Peso Bruto";
        result = false;
      } else if (isNaN(this.refVeic.pesoB)) {
        this.errosValidacao.pesoB = "O Peso Bruto deve ser um número válido";
        result = false;
      }

      if (!this.refVeic.nSerie) {
        this.errosValidacao.nSerie = "Informe o Serial (Série)";
        result = false;
      } else if (this.refVeic.nSerie.trim().length <= 0) {
        this.errosValidacao.nSerie = "Informe o Serial (Série)";
        result = false;
      }

      if (!this.refVeic.tpComb) {
        this.errosValidacao.tpComb = "Informe o Tipo de Combustível";
        result = false;
      } else if (this.refVeic.tpComb.trim().length <= 0) {
        this.errosValidacao.tpComb = "Informe o Tipo de Combustível";
        result = false;
      }

      if (!this.refVeic.nMotor) {
        this.errosValidacao.nMotor = "Informe o Número de Motor";
        result = false;
      } else if (this.refVeic.nMotor.trim().length <= 0) {
        this.errosValidacao.nMotor = "Informe o Número de Motor";
        result = false;
      }

      if (!this.refVeic.CMT) {
        this.errosValidacao.CMT = "Informe a Capacidade Máxima de Tração";
        result = false;
      } else if (isNaN(this.refVeic.CMT)) {
        this.errosValidacao.CMT =
          "A Capacidade Máxima de Tração deve ser um número válido";
        result = false;
      }

      if (!this.refVeic.dist) {
        this.errosValidacao.dist = "Informe a Distância entre Eixos";
        result = false;
      } else if (isNaN(this.refVeic.dist)) {
        this.errosValidacao.dist =
          "A Distância entre Eixos deve ser um número válido";
        result = false;
      }

      if (!this.refVeic.anoMod) {
        this.errosValidacao.anoMod = "Informe o Ano Modelo de Fabricação";
        result = false;
      } else if (isNaN(this.refVeic.anoMod)) {
        this.errosValidacao.anoMod =
          "O Ano Modelo de Fabricação deve ser um número válido";
        result = false;
      }

      if (!this.refVeic.anoFab) {
        this.errosValidacao.anoFab = "Informe o Ano de Fabricação";
        result = false;
      } else if (isNaN(this.refVeic.anoFab)) {
        this.errosValidacao.anoFab =
          "O Ano de Fabricação deve ser um número válido";
        result = false;
      }

      if (!this.refVeic.tpPint) {
        this.errosValidacao.tpPint = "Informe o Tipo de Pintura";
        result = false;
      } else if (this.refVeic.tpPint.trim().length <= 0) {
        this.errosValidacao.tpPint = "Informe o Tipo de Pintura";
        result = false;
      }

      if (!this.refVeic.tpVeic) {
        this.errosValidacao.tpVeic = "Informe o Tipo de Veículo";
        result = false;
      } else if (this.refVeic.tpVeic.trim().length <= 0) {
        this.errosValidacao.tpVeic = "Informe o Tipo de Veículo";
        result = false;
      }

      if (!this.refVeic.espVeic) {
        this.errosValidacao.espVeic = "Informe a Espécie de Veículo";
        result = false;
      } else if (this.refVeic.espVeic.trim().length <= 0) {
        this.errosValidacao.espVeic = "Informe a Espécie de Veículo";
        result = false;
      }

      if (!this.refVeic.VIN) {
        this.errosValidacao.VIN = "Informe a Condição do VIN";
        result = false;
      } else if (this.refVeic.VIN.trim().length <= 0) {
        this.errosValidacao.VIN = "Informe a Condição do VIN";
        result = false;
      }

      if (!this.refVeic.condVeic) {
        this.errosValidacao.condVeic = "Informe a Condição do Veículo";
        result = false;
      } else if (this.refVeic.condVeic.trim().length <= 0) {
        this.errosValidacao.condVeic = "Informe a Condição do Veículo";
        result = false;
      }

      if (!this.refVeic.cMod) {
        this.errosValidacao.cMod = "Informe o Código Marca Modelo";
        result = false;
      } else if (this.refVeic.cMod.trim().length <= 0) {
        this.errosValidacao.cMod = "Informe o Código Marca Modelo";
        result = false;
      }

      if (!this.refVeic.cCorDENATRAN) {
        this.errosValidacao.cCorDENATRAN = "Informe o Código da Cor";
        result = false;
      } else if (this.refVeic.cCorDENATRAN.trim().length <= 0) {
        this.errosValidacao.cCorDENATRAN = "Informe o Código da Cor";
        result = false;
      }

      if (!this.refVeic.lota) {
        this.errosValidacao.lota = "Informe a Capacidade Máxima de Lotação";
        result = false;
      } else if (isNaN(this.refVeic.lota)) {
        this.errosValidacao.lota =
          "A Capacidade Máxima de Lotação deve ser um número válido";
        result = false;
      }

      if (!this.refVeic.tpRest) {
        this.errosValidacao.tpRest = "Informe a Restrição";
        result = false;
      } else if (this.refVeic.tpRest.trim().length <= 0) {
        this.errosValidacao.tpRest = "Informe a Restrição";
        result = false;
      }

      return result;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_faturamento_editar_veiculo);
      this.$emit("exibirModalEditarVeiculo", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    if (this.index >= 0) {
      this.refVeic = JSON.parse(JSON.stringify(this.refVeicFaturamento));
    } else {
      this.refVeic = JSON.parse(JSON.stringify(refVeicInicializado));
    }
    this.errosValidacao = {};
    this.$utils.requestFocus("txttpOP");
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      refVeic: JSON.parse(JSON.stringify(refVeicInicializado)),
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 4,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: false,
      },
    };
  },
};
</script>

<style></style>
